module.exports = __webpack_public_path__ + "img/success.b3761e36.png";